import { render, staticRenderFns } from "./cartOktagon.vue?vue&type=template&id=42550af8&"
import script from "./cartOktagon.vue?vue&type=script&lang=js&"
export * from "./cartOktagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports